'use client';

import { useTranslations } from 'next-intl';

/**
 * Helper de résolution des messages d'erreur Zod pour les formulaires.
 *
 * Les schémas Zod stockent une **clé de traduction** dans `message`
 * (ex. `'emailInvalid'`). Au rendu, ce hook traduit la clé via
 * `t('errors.<key>')` dans le namespace passé en paramètre.
 *
 * Choix de design : Zod issue codes (`too_small`, `invalid_format`…) sont
 * trop coarse pour distinguer `firstNameRequired` de `passwordRequired`,
 * donc on garde la clé spécifique en `message` plutôt qu'un `customError`
 * global. Ce helper centralise simplement la résolution côté call site.
 *
 * Usage :
 *   const fieldError = useFieldError('auth');
 *   <Field error={fieldError(form.formState.errors.email?.message)} />
 */
export function useFieldError<NS extends 'auth' | 'onboarding'>(namespace: NS) {
  const t = useTranslations(namespace) as unknown as (key: string) => string;
  return (key: string | undefined): string | undefined => (key ? t(`errors.${key}`) : undefined);
}
